import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { PageContainer } from '@/components/layout/page-container'
import { FunnelCard } from '@/features/dashboard/funnel-card'
import { QuickLinks } from '@/features/dashboard/quick-links'
import { DASHBOARD_SEARCH_DEFAULTS, dashboardSearchSchema } from '@/features/dashboard/search'
import { SummaryAsOf, SummaryCards } from '@/features/dashboard/summary-cards'
import { TrendCard } from '@/features/dashboard/trend-card'

/**
 * 概览(根级菜单;URL 保持 /dashboard 不变,既有深链与用例不破)。
 *
 * 页面本身只做两件事:排版,以及把 search param 交给需要它的卡片;
 * 取数与图表实现都在 features/dashboard/ 下。
 * 默认区间(30 天)由 stripSearchParams 摘掉,裸 /dashboard 就是干净首屏。
 */
export const Route = createFileRoute('/_authed/dashboard')({
  validateSearch: dashboardSearchSchema,
  search: {
    middlewares: [stripSearchParams(DASHBOARD_SEARCH_DEFAULTS)],
  },
  component: DashboardPage,
})

function DashboardPage() {
  const { days } = Route.useSearch()
  /**
   * 模块清单取自 `_authed` 的 route context(那里的 beforeLoad 已 `ensureQueryData`)——
   * 快捷入口卡因此与左导航吃**同一份**清单:不另起 hook、不多等一个 loading 态,
   * 也就不会出现「导航已经不画订单了、卡片还画着」这种半拍不一致(★feat-008 W18)。
   */
  const { modules } = Route.useRouteContext()

  return (
    <PageContainer
      title="概览"
      breadcrumbs={[{ label: '概览' }]}
      description="线索、订单与回款的全局概览"
      actions={<SummaryAsOf />}
    >
      <SummaryCards />

      {/* 图表区:宽屏两卡并排,窄屏纵排 */}
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <FunnelCard />
        <TrendCard days={days} />
      </div>

      <QuickLinks modules={modules} />
    </PageContainer>
  )
}
